import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { P } from '@components/typography/new';
import { breakpoints, colors } from '../../../constants';
import { Flex } from '../../grid';
import { Icon } from '../../icons';

const CartButton = ({ onClick, quantity }) => {
  const quantityLabel = quantity < 100 ? quantity : '>99';
  const hasQuantity = quantity > 0;

  return (
    <Button onClick={onClick} data-testid="cart-button" aria-label="Cart">
      <Flex alignItems="center" px="24px" gap="8px">
        <Icon name="shoppingBag" width="35px" height="35px" />
        <P style={{ lineHeight: 1 }} variant="medium-link">
          Cart
        </P>
        {hasQuantity && (
          <P style={{ lineHeight: 1 }} variant="medium-link">
            {quantityLabel}
          </P>
        )}
      </Flex>
    </Button>
  );
};

const Button = styled.button`
  border-radius: 47px;
  height: 56px;

  background-color: ${colors.redPrimary};
  color: ${colors.white};
  fill: ${colors.white};

  &:hover {
    background-color: ${colors.red1};
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 20px;
  }
`;

CartButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
};

export { CartButton };
